"use client";

import { Avatar, Text } from "@pamperedchef/design-system";
import type { TestimonialItem } from "@/composites/landing/types";
import { Rating } from "@/composites/landing/Rating";
import * as styles from "./Testimonial.module.scss";

export type TestimonialProps = TestimonialItem;

/**
 * Single testimonial card — optional rating, quote, author name + meta, and an
 * avatar. The DS `Avatar` shows the author photo when provided and falls back
 * to a person icon otherwise (matching the Figma). Presentational, props-in.
 */
export function Testimonial({
	rating,
	quote,
	author_name,
	author_meta,
	avatar
}: TestimonialProps) {
	return (
		<figure className={styles["testimonial"]} data-component="Testimonial">
			{typeof rating === "number" ? <Rating value={rating} /> : null}

			<blockquote className={styles["testimonial__quote"]}>
				<Text tag="p" styledAs="mdr">
					{quote}
				</Text>
			</blockquote>

			<figcaption className={styles["testimonial__author"]}>
				<Avatar
					className={styles["testimonial__avatar"]}
					size="small"
					src={avatar?.url}
					alt={avatar?.alt ?? author_name}
				/>
				<span className={styles["testimonial__author-text"]}>
					<span className={styles["testimonial__author-name"]}>
						{author_name}
					</span>
					{author_meta ? (
						<span className={styles["testimonial__author-meta"]}>
							{author_meta}
						</span>
					) : null}
				</span>
			</figcaption>
		</figure>
	);
}
